require('./bootstrap')
window.Vue = require('vue')

import App from '@/js/App.vue'
import VueRouter from 'vue-router'
import VueAxios from 'vue-axios'
import axios from 'axios'
import store from '@/js/store'
import Vuelidate from 'vuelidate'
import Routes from '@/js/routes'
import { BootstrapVue } from 'bootstrap-vue'
import Member from '@/js/layouts/Member.vue'
import NonMember from '@/js/layouts/NonMember.vue'
import Nothing from '@/js/layouts/Nothing.vue'
import Default from '@/js/layouts/Default.vue'
import VueCookies from "vue-cookies"
import PDF from '@/js/layouts/PDF.vue'
import VueLazyload from 'vue-lazyload'
import VueLazyLoadVideo from 'vue-lazyload-video'
import '@/js/commons/filters'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import VuejsDialog from 'vuejs-dialog'
import 'vuejs-dialog/dist/vuejs-dialog.min.css'
import VueResizeObserver from "vue-resize-observer"
import VueGtag from "vue-gtag"
import '@/js/helpers'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import jaLocale from 'element-ui/lib/locale/lang/ja'
import { isLogout, setLogRocket } from "@/js/commons/commons"
import Vue2Editor from "vue2-editor";
import i18n from '@/lang/i18n';
if(process.env.MIX_LOCALE == 'en') {
  require('./../common/css/style-nanacara-vn.css')
}

Vue.use(ElementUI, {locale: jaLocale})
Vue.use(VueResizeObserver)
Vue.use(VuejsDialog)
Vue.use(BootstrapVue)
Vue.use(VueCookies)
Vue.router = Routes
Vue.use(VueRouter)
Vue.use(VueAxios, axios)
Vue.use(Vuelidate)
Vue.use(VueLazyload, {
  loading: require('./../common/img/loading.gif'),
  preLoad: 1.3
})
Vue.use(VueLazyLoadVideo)

Vue.use(VueGtag, {
  config: { id: (store.state.auth.typeOfUser === 'pharmacy' ? process.env.MIX_ANALYTICS_FOR_PHARMACY_TRACKING_ID : process.env.MIX_ANALYTICS_TRACKING_ID) },
})

Vue.component('member-layout', Member)
Vue.component('nonmember-layout', NonMember)
Vue.component('default-layout', Default)
Vue.component('pdf-layout', PDF)
Vue.component('nothing-layout', Nothing)

// Set Vue2Editor
Vue.use(Vue2Editor);

axios.defaults.baseURL = process.env.MIX_DR_API_HOST_NAME

if (!navigator.serviceWorker || !navigator.serviceWorker.register) {
  store.dispatch('app/setIsSupportServiceWorker', false)
} else {
  navigator.serviceWorker.addEventListener('message', function (event) {
    let eventOtpData = JSON.parse(event.data.firebaseMessaging.payload.data.otp_data)
    store.dispatch('otp/setOtpAccessToken', eventOtpData.one_time_access_key)
    store.dispatch('otp/setOtpLoading', false)
    if (eventOtpData.accept_flg != 0) {
      if (store.state.auth.doctorInfo.patient_histories_flg === 1) {
        Routes.push("/patient/" + eventOtpData.child_id)
      }
      else if(window.location.pathname !== "patient") {
        Routes.push("/patient")
      }
      else
        alert("Please reload for update Data")
    }

  })

  if (!navigator.serviceWorker.controller) {
    navigator.serviceWorker.register("firebase-messaging-sw.js")
        .then(function(registration) {
        })
        .catch(function(error) {
            store.dispatch('app/setIsSupportServiceWorker', false)
        })
  }
}
if(!isLogout()) {
  setLogRocket(store.state.auth.doctorInfo.email)
}

const app = new Vue({
  el: '#app',
  router: Routes,
  i18n,
  store,
  render: h => h(App),
})

